import React from 'react'

const P_series = () => {
    return (
        <div className='container'>
            <h1>Pandas - Series</h1>
            <p>Series is a one-dimensional labeled array capable of holding data of any
                 type (integer, string, float, python objects, etc.). The axis labels are 
                 collectively called index.</p>
                 <h3>pandas.Series</h3>
                 <p>A pandas Series can be created using the following constructor −</p> <br />
                 <div className='output'>
                 pandas.Series( data, index, dtype, copy)
                 </div>
                 <p>The parameters of the constructor are as follows −</p>
                 <table class="table table-bordered">
<tbody><tr>
<th style={{textAlign:'center'}}>Sr.No</th>
<th style={{textAlign:'center'}}>Parameter &amp; Description</th>
</tr>
<tr>
<td class="ts">1</td>
<td style={{textAlign:'center'}}>
<p><b>data</b></p>
<p>data takes various forms like ndarray, list, constants</p>
</td>
</tr>
<tr>
<td class="ts">2</td>
<td style={{textAlign:'center'}}>
<p><b>index</b></p>
<p>Index values must be unique and hashable, same length as data. Default <b>np.arrange(n)</b> if no index is passed.</p>
</td>
</tr>
<tr>
<td class="ts">3</td>
<td style={{textAlign:'center'}}>
<p><b>dtype</b></p>
<p>dtype is for data type. If None, data type will be inferred</p>
</td>
</tr>
<tr>
<td class="ts">4</td>
<td style={{textAlign:'center'}}>
<p><b>copy</b></p>
<p>Copy data. Default False</p>
</td>
</tr>
</tbody></table>
<p>A series can be created using various inputs like −</p> <br />
<ul>
    <li>Array</li>
    <li>Dict</li>
    <li>Scalar Value or cosntant</li>
</ul>
<h3>Create an Empty Series</h3>
<p>A basic series, which can be created is an Empty Series</p> <br />
<p><strong>Example</strong></p> <br />
<div className='containers'>
<code className='comment'>#import the pandas library and aliasing as pd</code> <br />
<code className='keywords'></code>import pandas as pd <br />
<code className='plain'>s = pd.Series</code>() <br />
<code className='library'>print</code> s <br /> <br /></div>
<p> Its <strong>output</strong>  is as follows −</p> 
<div className='output'>
Series([], dtype: float64)
</div>
<h3>Create a Series from ndarray</h3>
<p>If data is an ndarray, then index passed must be of the same length.
     If no index is passed, then by default index will be <b>range(n)</b> where
      <b>n</b> is array length, i.e., [0,1,2,3…. <b>range(len(array))-1].</b></p>
<div className='containers'>
<code className='comment'> #import the pandas library and aliasing as pd </code><br />
<code className='keywords'>import pandas as pd</code> <br />
<code className='keywords'>import numpy as np </code><br />
<code className='library'>data </code>= np.array(['a','b','c','d']) <br />
s = pd.Series(data) <br />
<code className='library'>print</code> s <br />
</div>
<div className='output'>
    <p><strong>Output:</strong></p>
    <pre>
        {`
        0   a
        1   b
        2   c
        3   d
        dtype: object`}
    </pre>
</div>
<p>We did not pass any index, so by default, it assigned the indexes ranging from 0 to
     <b>len(data)-1</b>, i.e., 0 to 3.</p>
     <h3>Create a Series from dict</h3>
     <p>A <b>dict</b> can be passed as input and if no index is specified, then the dictionary 
     keys are taken in a sorted order to construct index. If <b>index</b> is passed, 
     the values in data corresponding to the labels in the index will be pulled out.</p>
     <div className='containers'>
    <code  className='comment'> #import the pandas library and aliasing as pd</code> <br />
<code className='keywords'>import pandas as pd</code> <br />
<code className='keywords'>import numpy as np</code> <br />
<code className='keywords'>data</code> = &#123;'a' : 0., 'b' : 1., 'c' : 2.&#125; <br />
<code className='library'>s</code> = pd.Series(data) <br />
<code className='library'>print</code> s <br />
     </div>
     <div className='output'>
     a 0.0 <br />
b 1.0 <br />
c 2.0 <br />
dtype: float64 <br />
     </div>
    <strong> Observe</strong> − Dictionary keys are used to construct index.
    <h3>Create a Series from Scalar</h3>
    <p>If data is a scalar value, an index must be provided. The value will be repeated to match
the length of <b>index</b></p>
<div className='containers'>
<code className='comment'> #import the pandas library and aliasing as pd</code> <br />
<code className='keywords'> import pandas as pd</code> <br />
<code className='keywords'> import numpy as np </code><br />
s = pd.Series(5, index=[0, 1, 2, 3]) <br />
<code className='library'> print</code> s <br />
</div>
<div className='output'>
0  5 <br />
1  5 <br />
2  5 <br />
3  5 <br />
dtype: int64 <br />
</div>
<h3>Accessing Data from Series with Position</h3>
<p>Data in the series can be accessed similar to that in an <strong>ndarray</strong> .</p>
        <br />
        <p>Retrieve the first element. As we already know, the counting starts from zero for the array, which
             means the first element is stored at zeroth position and so on.</p>
       <div className='containers'>
      <code className='keywords'> import pandas as pd</code> <br />
<code className='keywords'> s</code> = pd.Series([1,2,3,4,5],index = ['a','b','c','d','e']) <br />
<code className='comment'> #retrieve the first element</code> <br />
<code className='library'> print</code> s[0] <br />
       </div>
       <div className='output'>
           <p><strong>Output</strong></p> <br />
           1
       </div>
       <h3>Retrieve Data Using Label (Index)</h3>
       <p>A Series is like a fixed-size <b>dict</b> in that you can get and set values by index label.</p>
       <div className='containers'>
       import pandas as pd <br />
s = pd.Series([1,2,3,4,5],index = ['a','b','c','d','e']) <br />
 <br />
#retrieve a single element <br />
print s['a'] <br />
       </div>
       <div className='output'>
           <p><strong>Output:</strong></p>
       1
       </div>
        </div>
    )
}

export default P_series
